module.exports = __webpack_public_path__ + "static/img/14_old.930e3530.png";